import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/p/bg.jpg';
import _imports_1 from '@/assets/p/logo.webp';
import _imports_2 from '@/assets/p/mobile_platform.webp';
const _withScopeId = n => (_pushScopeId("data-v-1862f158"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_0
}, null, -1));
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "flex mt-[80px]"
};
const _hoisted_4 = {
  class: "content-box-left"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-[64px] block",
  src: _imports_1
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-[61px] mt-[46px] block",
  src: _imports_2
}, null, -1));
const _hoisted_7 = {
  class: "scan-tip"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "scan-text"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_11 = {
  class: "qr-code"
};
const _hoisted_12 = {
  class: "code-box-left"
};
const _hoisted_13 = {
  class: "code-box"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "code-text"
};
const _hoisted_16 = {
  class: "code-box-right"
};
const _hoisted_17 = {
  class: "code-box"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "code-text"
};
const _hoisted_20 = {
  class: "content-box-right"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "footer"
};
const _hoisted_23 = {
  class: "app"
};
const _hoisted_24 = {
  class: "follow"
};
const _hoisted_25 = {
  class: "follow-text"
};
const _hoisted_26 = {
  class: "follow-group"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = ["src"];
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "platform"
};
const _hoisted_31 = {
  class: "follow-text"
};
const _hoisted_32 = {
  class: "follow-group"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = ["src"];
const _hoisted_35 = ["src"];
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-div"
}, null, -1));
const _hoisted_37 = {
  class: "footer-text"
};
import { useI18n } from "vue-i18n";
import QRCode from 'vue-qrcode-component';
export default {
  __name: 'PcPage',
  setup(__props) {
    const {
      locale
    } = useI18n();
    const imgResource = {
      zh_CN: {
        phone: require("@/assets/p/phone.png"),
        swipe: [require("@/assets/p/pc-zh/banner-1.webp"), require("@/assets/p/pc-zh/banner-2.webp"), require("@/assets/p/pc-zh/banner-3.webp")],
        app: require("@/assets/p/app.png"),
        h5: require("@/assets/p/h5.png"),
        fb: require("@/assets/p/F_B.png"),
        ins: require("@/assets/p/ins.png"),
        yt: require("@/assets/p/Y_T.png"),
        platform1: require("@/assets/p/platform1.png"),
        platform2: require("@/assets/p/platform2.png"),
        platform3: require("@/assets/p/platform3.png")
      },
      zh_TW: {
        phone: require("@/assets/p/phone.png"),
        swipe: [require("@/assets/p/pc-tw/banner-1.webp"), require("@/assets/p/pc-tw/banner-2.webp"), require("@/assets/p/pc-tw/banner-3.webp")],
        app: require("@/assets/p/app.png"),
        h5: require("@/assets/p/h5.png"),
        fb: require("@/assets/p/F_B.png"),
        ins: require("@/assets/p/ins.png"),
        yt: require("@/assets/p/Y_T.png"),
        platform1: require("@/assets/p/platform1.png"),
        platform2: require("@/assets/p/platform2.png"),
        platform3: require("@/assets/p/platform3.png")
      },
      en_US: {
        phone: require("@/assets/p/phone.png"),
        swipe: [require("@/assets/p/pc-en/banner-1.webp"), require("@/assets/p/pc-en/banner-2.webp"), require("@/assets/p/pc-en/banner-3.webp")],
        app: require("@/assets/p/app.png"),
        h5: require("@/assets/p/h5.png"),
        fb: require("@/assets/p/F_B.png"),
        ins: require("@/assets/p/ins.png"),
        yt: require("@/assets/p/Y_T.png"),
        platform1: require("@/assets/p/platform1.png"),
        platform2: require("@/assets/p/platform2.png"),
        platform3: require("@/assets/p/platform3.png")
      },
      en_MAS: {
        phone: require("@/assets/p/phone.png"),
        swipe: [require("@/assets/p/pc-ms/banner-1.webp"), require("@/assets/p/pc-ms/banner-2.webp"), require("@/assets/p/pc-ms/banner-3.webp")],
        app: require("@/assets/p/app.png"),
        h5: require("@/assets/p/h5.png"),
        fb: require("@/assets/p/F_B.png"),
        ins: require("@/assets/p/ins.png"),
        yt: require("@/assets/p/Y_T.png"),
        platform1: require("@/assets/p/platform1.png"),
        platform2: require("@/assets/p/platform2.png"),
        platform3: require("@/assets/p/platform3.png")
      },
      vi_VN: {
        phone: require("@/assets/p/phone.png"),
        swipe: [require("@/assets/p/pc-en/banner-1.webp"), require("@/assets/p/pc-en/banner-2.webp"), require("@/assets/p/pc-en/banner-3.webp")],
        app: require("@/assets/p/app.png"),
        h5: require("@/assets/p/h5.png"),
        fb: require("@/assets/p/F_B.png"),
        ins: require("@/assets/p/ins.png"),
        yt: require("@/assets/p/Y_T.png"),
        platform1: require("@/assets/p/platform1.png"),
        platform2: require("@/assets/p/platform2.png"),
        platform3: require("@/assets/p/platform3.png")
      }
    };
    function goThird(url) {
      window.open(url);
    }
    return (_ctx, _cache) => {
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        class: "phone-img",
        src: imgResource[_unref(locale)].phone
      }, null, 8, _hoisted_8), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('message.scan')), 1)]), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_unref(QRCode), {
        text: "https://pp88app.com",
        class: "code",
        size: 100
      }), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
        class: "code-img",
        src: imgResource[_unref(locale)].app
      }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('message.download')), 1)])]), _createElementVNode("div", _hoisted_16, [_createVNode(_unref(QRCode), {
        text: "https://pp88.com",
        class: "code",
        size: 100
      }), _createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        class: "code-img",
        src: imgResource[_unref(locale)].h5
      }, null, 8, _hoisted_18), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('message.h5')), 1)])])])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_van_swipe, {
        style: {
          "height": "100%",
          "width": "100%"
        },
        autoplay: 3000,
        vertical: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgResource[_unref(locale)].swipe, (image, index) => {
          return _openBlock(), _createBlock(_component_van_swipe_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "swipe-img",
              src: image
            }, null, 8, _hoisted_21)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })])])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('message.follow')), 1), _createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
        class: "follow-img",
        src: imgResource[_unref(locale)].fb,
        onClick: _cache[0] || (_cache[0] = $event => goThird(_ctx.fb))
      }, null, 8, _hoisted_27), _createElementVNode("img", {
        class: "follow-img",
        src: imgResource[_unref(locale)].ins,
        onClick: _cache[1] || (_cache[1] = $event => goThird(_ctx.ins))
      }, null, 8, _hoisted_28), _createElementVNode("img", {
        class: "follow-img",
        src: imgResource[_unref(locale)].yt,
        onClick: _cache[2] || (_cache[2] = $event => goThird(_ctx.yt))
      }, null, 8, _hoisted_29)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('message.platform')), 1), _createElementVNode("div", _hoisted_32, [_createElementVNode("img", {
        class: "platform-img",
        src: imgResource[_unref(locale)].platform1,
        style: {
          "margin-right": "2.448vw"
        }
      }, null, 8, _hoisted_33), _createElementVNode("img", {
        class: "platform-img",
        src: imgResource[_unref(locale)].platform2,
        style: {
          "margin-right": "1.5625vw"
        },
        onClick: _cache[3] || (_cache[3] = $event => goThird(_ctx.p1))
      }, null, 8, _hoisted_34), _createElementVNode("img", {
        class: "platform-img",
        src: imgResource[_unref(locale)].platform3,
        onClick: _cache[4] || (_cache[4] = $event => goThird(_ctx.p2))
      }, null, 8, _hoisted_35)])])]), _hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('message.footer')), 1)])])]);
    };
  }
};